export default {"src":"/_next/static/media/features-website-builder.c653e2e4.svg","height":58,"width":58,"blurWidth":0,"blurHeight":0};